import { useEffect } from 'react'
import { applyNativeUpdateNow, initializeNativeUpdates } from '../../services/nativeUpdateService'
import { useToast } from '../../context/useToast'

export const MobileUpdateBridge = () => {
  const { showToast } = useToast()

  useEffect(() => {
    initializeNativeUpdates((event) => {
      showToast(
        `Update available. Version ${event.version} will install after the app backgrounds or restarts.`,
        'info',
        {
          label: 'Install now',
          run: () => {
            void applyNativeUpdateNow(event).then((result) => {
              if (result.status === 'INSTALLED') {
                showToast(`Installing ${result.version || event.version}…`, 'success')
              } else if (result.status === 'CURRENT') {
                showToast('App is already up to date.', 'info')
              } else if (result.status === 'ERROR') {
                showToast(result.message, 'error')
              }
            })
          },
        },
      )
    })
  }, [showToast])

  return null
}
